var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.844,
    height: 36,
    viewBox: "0 0 35.844 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e5e5e5;}.b,.d{fill:#fff;}.c{fill:#64b161;}.d{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.766,36a.766.766,0,0,1-.739-.968l2.34-8.546A17.851,17.851,0,1,1,17.994,35.7h-.008a17.886,17.886,0,0,1-8.26-2.028L.96,35.974A.77.77,0,0,1,.766,36Zm0,0",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.894,45.363l2.424-8.85a17.085,17.085,0,1,1,14.8,8.555h-.007a17.07,17.07,0,0,1-8.164-2.079ZM20.371,39.9l.519.307a14.181,14.181,0,0,0,7.227,1.979h.005A14.2,14.2,0,1,0,16.093,35.53l.338.537L15,41.305Zm0,0",
    transform: "translate(-10.128 -10.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M19.344,52.658l2.34-8.544a16.493,16.493,0,1,1,14.292,8.258h-.007a16.49,16.49,0,0,1-7.881-2.007Zm0,0",
    transform: "translate(-17.983 -18.021)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.766 0.766)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.894,45.363l2.424-8.85a17.085,17.085,0,1,1,14.8,8.555h-.007a17.07,17.07,0,0,1-8.164-2.079ZM20.371,39.9l.519.307a14.181,14.181,0,0,0,7.227,1.979h.005A14.2,14.2,0,1,0,16.093,35.53l.338.537L15,41.305Zm0,0",
    transform: "translate(-10.894 -10.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M136.857,142.361c-.32-.711-.656-.725-.961-.737-.249-.011-.534-.01-.818-.01a1.569,1.569,0,0,0-1.138.534,4.785,4.785,0,0,0-1.494,3.56,8.3,8.3,0,0,0,1.743,4.415c.213.285,2.953,4.733,7.292,6.444,3.606,1.422,4.34,1.139,5.122,1.068a4.311,4.311,0,0,0,2.881-2.029,3.564,3.564,0,0,0,.249-2.03c-.107-.178-.391-.285-.818-.5s-2.525-1.246-2.917-1.389-.676-.213-.96.214-1.1,1.388-1.351,1.673-.5.321-.925.107a11.672,11.672,0,0,1-3.433-2.119,12.862,12.862,0,0,1-2.375-2.956c-.249-.427,0-.638.188-.871a12.873,12.873,0,0,0,1.067-1.46.787.787,0,0,0-.035-.748C138.066,145.316,137.236,143.205,136.857,142.361Zm0,0",
    transform: "translate(-123.899 -132.422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.a9bf34f33dca849bc61dc6e9c87d2cd6.svg";
export { ForwardRef as ReactComponent };